import { render } from "./NImageGallery.vue?vue&type=template&id=b846441a&ts=true"
import script from "./NImageGallery.vue?vue&type=script&lang=ts"
export * from "./NImageGallery.vue?vue&type=script&lang=ts"

import "./NImageGallery.vue?vue&type=style&index=0&id=b846441a&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__